import { Component, inject } from '@angular/core';
import { QuarryTypeService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  QuarryTypeCreateDto,
  QuarryTypeDto,
  QuarryTypeExcelDownloadDto,
  QuarryTypeUpdateDto,
} from '../proxy/controlling/dtos/quarry-type';
import { QUARRYTYPE_CONFIG, QUARRYTYPE_FIELDS } from './quarry-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-quarry-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, QuarryTypeService, ConfirmationService],
  templateUrl: './quarry-type.html',
  styleUrl: './quarry-type.scss',
})
export class QuarryType extends BaseCrudComponent<
  QuarryTypeDto,
  QuarryTypeCreateDto,
  QuarryTypeUpdateDto,
  QuarryTypeExcelDownloadDto
> {
  service = inject(QuarryTypeService);
  config = QUARRYTYPE_CONFIG;
  fields = QUARRYTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: QuarryTypeDto): QuarryTypeUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'QuarryType';
  }
}
